/**
 * basePath-aware URL builder for client-side fetches.
 *
 * With `basePath: "/v2"`, page routes and API route handlers live under /v2,
 * but a raw `fetch("/api/...")` targets the origin root and would 404. Prefix
 * every client-side call to our own API with this helper.
 * (Next's <Link>/router prepend basePath automatically; fetch does not.)
 */
export const BASE_PATH = process.env.NEXT_PUBLIC_BASE_PATH ?? "/v2";

export function apiUrl(path: string): string {
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${BASE_PATH}${p}`;
}

/** basePath-aware path to a /public asset (logo, brand images, …). */
export function assetPath(path: string): string {
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${BASE_PATH}${p}`;
}
